import {Link} from 'react-router-dom';
import {ReactNode} from 'react';

type ConditionalLinkProps = {
    to: string|null;
    state?: any;
    children: ReactNode;
    [key: string]: any;
}

const ConditionalLink = ({ to, state, children, ...rest }: ConditionalLinkProps) => {
    return to
        ? <Link to={ to } state={ state } {...rest}>{children}</Link>
        : <a href={'/404'}>{children}</a>
        ;
}

export default ConditionalLink;
